import { IconProps } from '.';

const PinterestIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_8792_14995)">
        <path
          d="M13.5 0C6.31953 0 0.5 5.81953 0.5 13C0.5 18.5098 3.92773 23.2121 8.76211 25.1063C8.65039 24.0754 8.54375 22.5012 8.80781 21.3789C9.04648 20.3633 10.3313 14.9195 10.3313 14.9195C10.3313 14.9195 9.94023 14.1426 9.94023 12.9898C9.94023 11.182 10.9863 9.83125 12.2914 9.83125C13.3984 9.83125 13.9367 10.6641 13.9367 11.6645C13.9367 12.7816 13.2258 14.4473 12.8602 15.991C12.5555 17.2859 13.5102 18.3422 14.7848 18.3422C17.0953 18.3422 18.8727 15.9047 18.8727 12.3906C18.8727 9.27773 16.6383 7.09922 13.4441 7.09922C9.74726 7.09922 7.57383 9.87187 7.57383 12.741C7.57383 13.8582 8.00547 15.0566 8.54375 15.7066C8.65039 15.8336 8.66562 15.9504 8.63516 16.0773C8.53867 16.4887 8.31524 17.3723 8.27461 17.55C8.21875 17.7887 8.08672 17.8395 7.83789 17.7227C6.21289 16.966 5.19727 14.5945 5.19727 12.6852C5.19727 8.58203 8.17813 4.81914 13.7844 4.81914C18.2938 4.81914 21.7977 8.0336 21.7977 12.3297C21.7977 16.8086 18.9742 20.4141 15.0539 20.4141C13.7387 20.4141 12.4996 19.7285 12.073 18.9211C12.073 18.9211 11.423 21.4043 11.2656 22.0137C10.9711 23.141 10.1789 24.5578 9.65078 25.4211C10.8695 25.7969 12.1594 26 13.5 26C20.6805 26 26.5 20.1805 26.5 13C26.5 5.81953 20.6805 0 13.5 0Z"
          fill={color || 'var(--color-ui-stroke-primary'}
        />
      </g>
      <defs>
        <clipPath id="clip0_8792_14995">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PinterestIcon;
